// libs
import React, { memo, useCallback } from 'react';

//styles
import { SearchContainer, InputSearchIcon, CloseIcon, InputField } from './styles';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

//constants
import { SEARCH, SEARCH_ICON_SIZE, CLOSE_ICON_SIZE } from './constants';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';


// utils
import { sanitizeInput } from 'shared/components/GlobalSearch/components/SearchWidget/utils';

// defs
interface ISearchBar {
  searchText: string;
  title: string;
  setSearchText: (text: string) => void;
}

function SearchBar({ searchText, setSearchText, title }: ISearchBar) {
  const theme: Theme = useTheme();
  const SearchIconComponent = useStoreIcon(IconName.SEARCH);
  const CloseIconComponent = useStoreIcon(IconName.CIRCLE_X_FILLED);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const sanitized = sanitizeInput(e.target.value);
      setSearchText(sanitized);
    },
    [setSearchText]
  );

  return (
    <SearchContainer>
      <InputSearchIcon as={SearchIconComponent} size={SEARCH_ICON_SIZE} color={theme.colors.textSecondary} />
      <InputField
        type="text"
        placeholder={`${SEARCH} ${title}`}
        value={searchText}
        onChange={handleChange}
      />
      {searchText.length > 0 && (
        <CloseIcon
          as={CloseIconComponent}
          size={CLOSE_ICON_SIZE}
          onClick={() => setSearchText('')}
          color={theme.colors.textDisabled}
        />
      )}
    </SearchContainer>
  );
}

export default memo(SearchBar);
